<template>
  <div class="blog-detail-container" v-loading="isLoading">
    <Layout>
      <template #main>
        <BlogContent :blogContent="blogData" v-if="blogData" />
      </template>
      <template #right>
        <BlogList :list="blogData.toc" v-if="blogData"></BlogList>
      </template>
    </Layout>
  </div>
</template>

<script>
import Layout from '@/components/Layout';
import BlogContent from './BlogContent'
import BlogList from './BlogList';
import { getBlog } from '@/api/blog';
import titleControl from '@/utils/titleControl';
export default {
  components: {
    Layout,
    BlogContent,
    BlogList
  },
  data() {
    return {
      blogData: null,
      isLoading: true,
    }
  },
  created() {
    getBlog(this.$route.params.id).then(r => {
      this.isLoading = false
      this.blogData = r.data.data;
      if (this.blogData.title) {
        titleControl.setRouteTitle(this.blogData.title)
      }
    })
  },
  methods: {
    handleChange(e) {
      console.log(e)
    }
  }
}
</script>

<style scoped lang="less">
.blog-detail-container {
  width: 100%;
  height: 100%;
}

.blog-list-container {
  width: 350px;
}
</style>